import { Container, Typography,Box, IconButton, Grid } from '@mui/material';
import { 
  Phone as PhoneIcon, 
  Email as EmailIcon, 
  // LocationOn as LocationIcon,
  Facebook as FacebookIcon,
  Instagram as InstagramIcon
} from '@mui/icons-material';
import { ContactItem, Copyright, FooterTitle, FooterWrapper } from './footer.styled';


const Footer = () => {
  return (
    <FooterWrapper>
      <Container>
        <Grid container spacing={2}>
          <Grid size={{xs:12, md:4 }}>
            <FooterTitle variant="h6">Klarity</FooterTitle>
            <Typography variant="body2" sx={{ mb: 1, color: 'rgba(255, 255, 255, 0.8)' }}>
              Premium eye care solutions using naturally-derived ingredients for reducing eye bags and dark circles.
            </Typography>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <IconButton
                size="small"
                sx={{ color: 'rgba(255, 255, 255, 0.8)' }}
                onClick={() => window.open('https://www.facebook.com/profile.php?id=61576340227941#', '_blank')}
              >
                <FacebookIcon />
</IconButton>I

              <IconButton
                size="small"
                sx={{ color: 'rgba(255, 255, 255, 0.8)' }}
                onClick={() => window.open('https://www.instagram.com/klarity.lb?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw== ', '_blank')}
              >
                <InstagramIcon />
              </IconButton>
            </Box>
          </Grid>
          
          <Grid  size={{xs:12, md:4 }}>
            <FooterTitle variant="h6">Contact Us</FooterTitle>
            <ContactItem>
              <PhoneIcon fontSize="small" />
              <a href="tel:+96170054875" style={{ textDecoration: 'none', color: 'inherit' }}>
                <Typography variant="body2">+961 78 723 563</Typography>
              </a>
            </ContactItem>
            <ContactItem>
                <EmailIcon fontSize="small" />
                <a href="mailto:karenhassoun101@outlook.com" style={{ textDecoration: 'none', color: 'inherit' }}>
                  <Typography variant="body2">karenhassoun101@gmail.com</Typography>
                </a>
          </ContactItem>
          </Grid>
        </Grid>
        
        <Copyright variant="body2">
          &copy; {new Date().getFullYear()} Klarity Beauty. All rights reserved.
        </Copyright>
      </Container>
    </FooterWrapper>
  );
};

export default Footer;